import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { ensureAuthenticatedSessionAsync, getActiveAccount } from '../../services/auth/AuthService';
import { trackException } from '../telemetry/appInsights';

export interface InitializeAuthResult {
    // Null when the session bootstrap did not produce a usable account.
    // Callers should treat null as "unauthenticated" and take recovery action.
    activeAccount: AccountInfo | null;
}

export interface InitializeAuthArgs {
    msalInstance: IPublicClientApplication;
}

export const initializeAuth = async ({ msalInstance }: InitializeAuthArgs): Promise<InitializeAuthResult> => {
    try {
        await ensureAuthenticatedSessionAsync({ msalInstance });
    } catch (error) {
        trackException(error, {
            source: 'initializeAuth.ensureAuthenticatedSessionAsync',
        });
    }

    return { activeAccount: getActiveAccount(msalInstance) };
};
